/**
 * Navega para a homepage com reload completo e scroll ao topo.
 * Funciona em desktop, tablet e mobile (touch).
 */
export function goToHomePage(event) {
  if (event) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }

  window.scrollTo(0, 0)

  const { pathname, search, hash } = window.location
  if (pathname === '/' && !search && !hash) {
    window.location.reload()
  } else {
    window.location.href = '/'
  }
}
